import { z } from 'zod';
import { newReactionSchema } from '@/models/newReactionSchema';
import { modelElementSchema } from '@/models/modelElementSchema';

export const bioEntityContentSchema = z.object({
  bioEntity: z.union([newReactionSchema, modelElementSchema]),
  /** indicates if bioEntity matches perfect match even if not provided in query */
  perfect: z.boolean(),
});
